"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BDSTabMenu = void 0;
var tslib_1 = require("tslib");
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = tslib_1.__importDefault(require("react"));
var Theme_1 = require("../../../../Theme");
var BDSTabMenu_style_1 = require("./BDSTabMenu.style");
var BDSTabMenu = function (_a) {
    var tabList = _a.tabList, selectedTab = _a.selectedTab, handleTab = _a.handleTab, style = _a.style;
    var theme = Theme_1.lightTheme;
    return (jsx_runtime_1.jsx(react_1.default.Fragment, { children: jsx_runtime_1.jsx("div", tslib_1.__assign({ style: style || {}, css: [BDSTabMenu_style_1.BGTabWrapperCSS(theme)] }, { children: tabList.map(function (tab) {
                return (jsx_runtime_1.jsxs("div", tslib_1.__assign({ className: "tab-panel " + (tab.key === selectedTab.key ? 'active' : '') + " " + (tab.key !== selectedTab.key && tab.isActiveAlarm ? 'relative' : ''), "data-testid": "bg-tab-panel", onClick: function () { return handleTab(tab); } }, { children: [tab.key !== selectedTab.key && tab.isActiveAlarm && jsx_runtime_1.jsx("div", { className: "alarm-area" }, void 0), tab.label] }), tab.key));
            }) }), void 0) }, void 0));
};
exports.BDSTabMenu = BDSTabMenu;
